
















	import { Vue,Component,Prop,Model,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import exicon from '../assets/js/expressicon'
    const common = namespace('common')
    @Component
    export default class Excom extends Vue{
        @common.State('partnerList') list:any
        @Model('change', { type: String }) value!: String
        partnerIcon:string = '' //快递员图标
        exicon:any = exicon
        val:any = ''
        @common.Action('getPartner') getPartnerList:any
        async created(){
            await this.getPartnerList()
            this.val = this.value
            this.list.map((item:any)=>{
                if(item._id == this.value){
                    this.partnerIcon = item.excom.pinyin
                } 
            })
        }
        change(e:any){
            this.$emit('change',e)
            if(e){
                this.list.map((item:any)=>{
                    if(item._id == e){
                        this.partnerIcon = item.excom.pinyin
                    } 
                })
            }else{
                this.partnerIcon = ''
            }
        }
        @Watch('value')
        onChildChanged(val: string, oldVal: string) {
            this.val = val
            this.list.map((item:any)=>{
                if(item._id == val){
                    this.partnerIcon = item.excom.pinyin
                } 
            })
        }
    }
